// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { Gender } from "../schema";

export function serialize_Gender_internal(value: Gender): unknown {
  return ((value: "FEMALE" | "MALE" | "UNKNOWN" | "CUSTOM"): unknown => {
    return value;
  })(value);
}
export function serialize_Gender(obj: Gender): string {
  return renderJsonWithNumbersAsBigint(serialize_Gender_internal(obj));
}
export function deserialize_Gender_internal(value: unknown): ParserResult<Gender> {
  return ((value: unknown): ParserResult<"FEMALE" | "MALE" | "UNKNOWN" | "CUSTOM"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/Gender]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "FEMALE":
        return { success: true, value: "FEMALE" };
      case "MALE":
        return { success: true, value: "MALE" };
      case "UNKNOWN":
        return { success: true, value: "UNKNOWN" };
      case "CUSTOM":
        return { success: true, value: "CUSTOM" };
      default:
        return { success: false, reason: `[#/components/schemas/Gender]: '${value}' expected to be enum, one of 'FEMALE, MALE, UNKNOWN, CUSTOM'.` };
    }
  })(value);
}
export function deserialize_Gender(str: string): ParserResult<Gender> {
  return deserialize_Gender_internal(parseJsonWithNumbersAsBigint(str));
}
